"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotIndicator = DotIndicator;
const jsx_runtime_1 = require("react/jsx-runtime");
const utilities_1 = require("@kalkulacka-one/design-system/utilities");
const class_variance_authority_1 = require("class-variance-authority");
const DotIndicatorVariants = (0, class_variance_authority_1.cva)("ko:rounded-full ko:h-2", {
    variants: {
        status: {
            active: "ko:w-5 ko:bg-neutral-active",
            inactive: "ko:w-2 ko:bg-neutral-inactive",
        },
    },
});
function DotIndicator({ stepTotal, stepCurrent }) {
    if (stepCurrent <= 0 || stepTotal <= 0 || stepCurrent > stepTotal) {
        if (process.env.NODE_ENV !== "production") {
            throw new Error("DotIndicator: Invalid props - stepCurrent and stepTotal must be positive numbers, and stepCurrent must not exceed stepTotal");
        }
    }
    const stepArray = Array.from({ length: stepTotal }, (_, index) => index);
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, utilities_1.twMerge)("ko:flex ko:gap-1"), role: "progressbar", "aria-valuenow": stepCurrent, "aria-valuemin": 1, "aria-valuemax": stepTotal, "aria-label": `Step ${stepCurrent} of ${stepTotal}`, children: stepArray.map((step, index) => {
            return ((0, jsx_runtime_1.jsx)("div", { className: (0, utilities_1.twMerge)(DotIndicatorVariants({
                    status: stepCurrent === index + 1 ? "active" : "inactive",
                })) }, step));
        }) }));
}
